import Footer from '@components/shared/Footer/Footer';
import SoftPullAcknowledgementPage from '@components/SoftPullAcknowledgementPage/SoftPullAcknowledgementPage';
import { useTexts } from 'utils/useTexts';

const SoftPullAcknowledgement = () => {
  const { t } = useTexts();
  return (
    <>
      <SoftPullAcknowledgementPage />

      <Footer text={t('softPullAcknowledgement.footer')} />
    </>
  );
};

export default SoftPullAcknowledgement;
